export const clearStoragePreservingTours = () => {
  const keysToRemove: string[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (
      key &&
      !key.startsWith("tour_seen_") &&
      !key.startsWith("tour_modal_count") &&
      !key.startsWith("ec_unlocked_toast_seen_") &&
      // Device-level "already seen/dismissed" flags (promo cards, "New" badges)
      // must survive logout, otherwise dismissed promos reappear on next login.
      !key.startsWith("persist_") &&
      key !== "preferred_login_method"
    ) {
      keysToRemove.push(key);
    }
  }

  // Remove only non-tour keys
  keysToRemove.forEach((key) => {
    localStorage.removeItem(key);
  });

  sessionStorage.clear();
};

export const savePreferredLoginMethod = (method: "email" | "mobile") => {
  localStorage.setItem("preferred_login_method", method);
};

export const getPreferredLoginMethod = (): "email" | "mobile" | null => {
  const method = localStorage.getItem("preferred_login_method");
  return method === "email" || method === "mobile" ? method : null;
};

export const hasSeenGlobalTour = (): boolean => {
  return localStorage.getItem("tour_seen_app") === "true";
};

export const markGlobalTourAsSeen = (): void => {
  localStorage.setItem("tour_seen_app", "true");
};
